import logout from './logout';
import setToken from './setToken';

const interceptors = {
  logout,
  setToken,
};

export default interceptors;
